module.exports = __webpack_public_path__ + "static/img/证书2.e5287a29.jpg";